export const SampleStatusData = {
    "title":"",
    "caseCount":0,
    "caseName":"Total Test Results",
    "text1":"Total",
    "text2":"Samples",
    "typeOfCase":[]
}

export const ReportStatusData = {
    "title": "",
    "caseCount": 0,
    "caseName": "Total Test Results",
    "text1": "Total",
    "text2": "Reports",
    "typeOfCase": []
}

export const TotalSampleStatusData = {
    "title":"Sample Status",
    "caseCount":720,
    "text1":"Total",
    "text2":"Samples",
    "typeOfCase":[ ],
 }
 export const TotalReportStatusData = {
    "title":"Report Status",
    "text1":"Total",
    "text2":"Reports",
    "caseCount":720,
    "typeOfCase":[ ],
 }

export const SampleStatusColor = ["#002040","#01268e", "#007498", "#5cf9cf"];
// export const SampleStatusColor = ["#01268e","#002040", "#5cf9cf", "#007498" ];

// export const ReportStatusColor = ["#d50000","#dc7803", "#00a727", "#6bbfa1"];
export const ReportStatusColor = ["#d50000","#dc7803", "#00a727","#6bbfa1"];


// {
//     "title":"FQT",
//     "caseCount":70,
//     "caseName":"Total Test Results",
//     "text1":"Total",
//     "text2":"Test Result",
//     "typeOfCase":[
//       {
//          "title":"Arrived at the lab",
//          "color":"#002040",
//          "value":90
//       },
//       {
//          "title":"Analysed",
//          "color":"#01268e",
//          "value":80
//       },
//       {
//          "title":"Reported",
//          "color":"#007498",
//          "value":50
//       },
//       {
//          "title":"Other",
//          "color":"#5cf9cf",
//          "value":30
//       }
//     ]
// }